let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lFjak")).then(() => parcelRequire('iL5M3'));